module.exports = __webpack_public_path__ + "static/media/step_20.6c44e2a0.mp3";